import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Switch,Snackbar,Alert } from "@mui/material";
import axios from "axios";
import Header from "components/Header";
import { DataGrid } from "@mui/x-data-grid";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
 
const BestSolution = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [data, setData] = useState([]); 
  const [isLoading, setIsLoading] = useState(true); 
  const [imagePath, setImagePath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [currentSolution, setCurrentSolution] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState("");

  useEffect(() => {
    fetchSolutions();
  }, []);

  const fetchSolutions = async () => {
    try {
      const response = await axios.get(`${apiUrl}/bsolution/getbsolution`); // Adjust this to your API endpoint
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading(false);
    }
  };

  const handleOpenModal = (solution) => {
    if (solution) {
      setCurrentSolution(solution);
      setTitle(solution.title);
      setDescription(solution.description);
      setImagePath(solution.image);
    } else {
      setCurrentSolution(null);
      setTitle("");
      setDescription("");
      setImagePath("");
    }
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentSolution(null);
  };
   
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const handleFileChangeProcess = (event) => {
    const selectedImage = event.target.files[0];
    if (selectedImage) {
      handleImageUpload(selectedImage, setImagePath); // Automatically upload the image
    }
  };
  const handleImageUpload = async (file, setImagePath) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const response = await axios.post(`${apiUrl}/upload`, formData);
      console.log("this is image path>>:", response.data.filePath);
      // setImagePath(response.data.filePath); // Assuming the backend returns the image path
      setImagePath(response.data.url);
    } catch (error) {
      console.error("Error uploading image:", error);
      setErrorMessage("Error uploading image.");
      setSnackbarOpen(true);
    }
  };
   
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!title || !description|!imagePath) {
      setErrorMessage("Please fill all the required fields.");
      setSnackbarOpen(true);
      return;
    }
    const postData = {
      title,
      description,
      image:imagePath
    };

    try {
      const response = await axios.post(`${apiUrl}/bsolution/createbsolution`, postData);
      setData((prevData) => [...prevData, response.data]);
      handleCloseModal();
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (!title || !description|!imagePath) {
      setErrorMessage("Please fill all the required fields.");
      setSnackbarOpen(true);
      return;
    }
    const updateData = {
      title,
      description,
      image:imagePath
    };

    try {
      const response = await axios.put(`${apiUrl}/bsolution/updatebsolution/${currentSolution._id}`, updateData);
      setData((prevData) =>
        prevData.map((item) => (item._id === currentSolution._id ? response.data : item))
      );
      handleCloseModal();
    } catch (error) {
      console.error("Error updating solution:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${apiUrl}/bsolution/deletebsolution/${id}`);
      setData((prevData) => prevData.filter((item) => item._id !== id));
    } catch (error) {
      console.error("Error deleting solution:", error);
    }
  };

  

  const columns = [
    
    { field: "title", headerName: "Title", flex: 0.5 },
    { field: "description", headerName: "Description", flex: 0.5 },
    { field: "image", headerName: "Image", flex: 0.5, renderCell: (params) => (
      // <img src={`${apiUrl}/${params.row.image}`} alt={params.row.title} width="50" height="50" />
      <img
          src={params.row.image}
          alt={params.row.title}
          width="50"
          height="50"
        />
    )},
     
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      renderCell: (params) => (
        <>
          <Button variant="contained"  style={{marginRight: 8}} color="primary" size="small" onClick={() => handleOpenModal(params.row)}>
            Update
          </Button>
          <Button variant="contained" color="secondary" size="small" onClick={() => handleDelete(params.row._id)}>
            Delete
          </Button>
        </>
      ),
    },
  ];
console.log("this is api url kdfjsdlfjsdlfj>>>>>>>>>>>>>>meemee",apiUrl)
  return (
    <Box m="1.5rem 2.5rem">
      <Header title="WE DELIVERED BEST SOLUTION" subtitle="List of Best Solutions" />
      <Button variant="contained" color="primary" onClick={() => handleOpenModal(null)}>
        Add New Solution
      </Button>

      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>{currentSolution ? "Update Solution" : "Add New Solution"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            type="text"
            fullWidth
            variant="outlined"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Description"
            type="text"
            fullWidth
            variant="outlined"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Button
            variant="outlined"
            component="label"
            startIcon={<CloudUploadIcon />}
          >
            Upload Image
            <input
              type="file"
              hidden
              onChange={handleFileChangeProcess} // Store the file object instead
            />
          </Button>
          {imagePath && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {/* <img src={`${apiUrl}/${imagePath}`} alt="image" width="50" height="50" /> */}
              <img src={imagePath} alt="image" width="50" height="50" />
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">
            Cancel
          </Button>
          <Button onClick={currentSolution ? handleUpdate : handleSubmit} color="primary">
            {currentSolution ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Box mt="40px" height="75vh">
        <DataGrid
          loading={isLoading}
          getRowId={(row) => row._id}
          rows={data || []}
          columns={columns}
          pageSize={5}
        />
      </Box>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BestSolution;
